/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RulesInputs */

const en_nav_rules = /** @type {(inputs: Nav_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules`)
};

const de_nav_rules = /** @type {(inputs: Nav_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeln`)
};

/**
* | output |
* | --- |
* | "Rules" |
*
* @param {Nav_RulesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_rules = /** @type {((inputs?: Nav_RulesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RulesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_rules(inputs)
	return de_nav_rules(inputs)
});